import React from 'react';
import { Card } from '@/components/ui/card';
import { MapPin } from 'lucide-react';

export function FallbackMap() {
  return (
    <Card className="w-full h-[600px] flex items-center justify-center bg-muted/10">
      <div className="text-center">
        <MapPin className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
        <p className="text-muted-foreground">Map preview unavailable</p>
      </div>
    </Card>
  );
}